import { apiInstance } from "../utils/_apiInstance";

export const deleteSavedSearch = async (id: string) => {
  const response = await apiInstance.delete(`/pesquisas-salvas/${id}`);
  return response.data;
};
